/* Certificate — bằng tốt nghiệp: bản xem trước (watermark) hoặc bản đã cấp. */
import { Icon } from "@/components/icon"
import { Page, PageHeader, usePageTitle } from "@/components/page"
import { useClass } from "@/app/ClassLayout"
import { cn } from "@/lib/utils"
import { QuietDetails } from "./start-awards/shared"

const viDate = (v: string) => new Date(v).toLocaleDateString("vi-VN")

export default function CertificatePage() {
  const { data } = useClass()
  const course = data.class || {}
  const learner = data.learner || {}
  const certificate = data.certificate
  const issued = certificate?.status === "issued"
  usePageTitle("Bằng tốt nghiệp", "Chứng nhận hoàn thành khóa học Simba.")
  const date = issued ? viDate(certificate.issued_at) : course.end_date ? viDate(course.end_date) : "Sau khi hoàn thành khóa học"

  return (
    <Page>
      <PageHeader eyebrow={issued ? "Đã hoàn thành" : "Đích đến"} title="Bằng tốt nghiệp" />
      <section
        aria-label="Bằng tốt nghiệp"
        className={cn("relative overflow-hidden rounded-[24px] border-[1.5px] border-edge bg-paper p-3 shadow-card sm:p-5", !issued && "select-none")}
      >
        {!issued && (
          <span aria-hidden className="pointer-events-none absolute inset-0 grid place-items-center">
            <span className="-rotate-12 font-heading text-4xl font-black tracking-[0.12em] whitespace-nowrap text-orange/15 sm:text-7xl">BẢN XEM TRƯỚC</span>
          </span>
        )}
        <div className="flex flex-col items-center gap-4 rounded-[18px] border-2 border-double border-gold/60 px-4 py-8 text-center sm:px-10 sm:py-12">
          <div className="flex items-center gap-3">
            <img src="/brand/sutucon-logo.png" alt="" className="size-12 rounded-full" />
            <span className="flex flex-col text-left">
              <strong className="font-heading text-lg font-black tracking-[0.12em] text-ink">SIMBA</strong>
              <span className="text-sm tracking-[0.08em] text-muted-foreground">FAMILY LEARNING PORTAL</span>
            </span>
          </div>
          <p className="text-sm font-bold tracking-[0.08em] text-orange uppercase">Chứng nhận hoàn thành khóa học</p>
          <h2 className="font-heading text-2xl font-bold text-ink sm:text-3xl">{course.course_name}</h2>
          <span className="text-sm text-muted-foreground">Trân trọng trao cho</span>
          <h3 className="font-heading text-3xl font-black break-words text-orange-strong sm:text-5xl">{learner.full_name}</h3>
          <p className="max-w-lg text-base text-ink">
            vì đã bền bỉ học tập, sáng tạo và hoàn thành hành trình <strong>{course.name}</strong>.
          </p>
          <div className="mt-2 grid w-full max-w-xl grid-cols-1 items-center gap-4 border-t border-line pt-6 sm:grid-cols-[1fr_auto_1fr]">
            <span className="flex flex-col gap-0.5">
              <span className="text-sm text-muted-foreground">Ngày hoàn thành</span>
              <strong className="text-ink">{date}</strong>
            </span>
            <Icon name="star" className="mx-auto size-7 text-gold" />
            <span className="flex flex-col gap-0.5">
              <span className="text-sm text-muted-foreground">Mã chứng nhận</span>
              <strong className="break-all text-ink">{issued ? certificate.certificate_number : "SẼ CẤP KHI HOÀN THÀNH"}</strong>
            </span>
          </div>
        </div>
      </section>
      <QuietDetails summary={issued ? "Cách xác minh bằng" : "Khi nào con nhận được bằng?"}>
        <p>
          {issued
            ? "Dùng mã chứng nhận trên bằng để xác minh."
            : "Khi con hoàn thành khóa học và được xác nhận, watermark sẽ biến mất và mã chứng nhận chính thức sẽ xuất hiện."}
        </p>
      </QuietDetails>
    </Page>
  )
}
